export interface EventsServiceContract {
    startupAsync(): Promise<void>;
    on(event: string, handler: (args: any[]) => void): void;
    off(event: string, handler: (args: any[]) => void): void;
    raise(event: string, args: any): void;
    reconnect(): void;
}

export interface ContextRelatedEvent {
    contextId: number;
    type?: string;
}

export interface ProcessingStartedEvent extends ContextRelatedEvent {
    averageProcessingTime: number;
    processingRequestId: number;
    type: string;
}

export enum Events {
    // Client-side:
    ContextChanged = 'contextChangedEvent',
    SettingsChanged = 'settingChangeEvent',

    // Server-side:
    ProcessingStarted = 'processingStartedEvent',
    ProcessingFinished = 'processingFinishedEvent',
    ProcessingTerminated = 'processingTerminatedEvent',
    ProcessingAborted = 'processingAbortedEvent'
}

export enum CustomEvents {
    PlannedOperationsPageClosed = 'plannedOperationPageClosedEvent'
}
